export const videos = {
  cloudSiemOnboarding: '//fast.wistia.com/embed/iframe/00ovo11ahn', // //play.vidyard.com/1NBL5ZEsqQtzEhGasLe4f9.html',
  infrastructureMonitoringDemo: '//fast.wistia.com/embed/iframe/8dl4yzrb0b', // //play.vidyard.com/T7qQRbz67MrW6krTsbiwTU.html',
  logManagementDemo: '//fast.wistia.com/embed/iframe/6x7ra88n6h', // //play.vidyard.com/Kyp6GkJ39U1jNbjjAa1CM1',
  distributedTracingDemo: '//fast.wistia.com/embed/iframe/zs52wpyuzz', // //play.vidyard.com/7m2hSKcLTPin5WUS7i1rSx',
};
